import React from 'react';
import { FETCH_ORGANISATION, FETCH_ORGANISATION_SUCCESS, FETCH_ORGANISATION_FAILER, FETCH_SLA, FETCH_SLA_SUCCESS, FETCH_SLA_FAILER } from './SLAActionTypes';

interface IInitialState {
    loading: boolean,
    SLAData: any,
    error: string,

    organisationLoading: boolean,
    organisationData: any,
    organisationError: string,
}

const initialState: IInitialState = {
    loading: false,
    SLAData: [],
    error: "",

    organisationLoading: false,
    organisationData: [],
    organisationError: "",
};
const SLAReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_SLA:
            return {
                ...state,
                loading: true,
                SLAData: [],
                error: ""
            }
        case FETCH_SLA_SUCCESS:
            return {
                ...state,
                loading: false,
                SLAData: action.payload,
                error: ""
            }
        case FETCH_SLA_FAILER:
            return {
                ...state,
                loading: false,
                SLAData: [],
                error: action.payload
            }
        case FETCH_ORGANISATION:
            return {
                ...state,
                organisationLoading: true,
                organisationData: [],
                organisationError: ""
            }
        case FETCH_ORGANISATION_SUCCESS:
            return {
                ...state,
                organisationLoading: false,
                organisationData: action.payload,
                organisationError: ""
            }
        case FETCH_ORGANISATION_FAILER:
            return {
                ...state,
                organisationLoading: false,
                organisationData: [],
                organisationError: action.payload
            }

        default:
            return { ...state, }
    }
}

export default SLAReducer;